import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IAIAgentTemplate } from '../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const AI_AGENT_TEMPLATES_QUERY_KEY = 'aiAgentTemplatesQuery';

export function useAIAgentTemplatesQuery({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IAIAgentTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'aiagenttemplate' }),
				'GET'
			);
		},
		queryKey: [AI_AGENT_TEMPLATES_QUERY_KEY],
	});
}
